<div class="component-filters">
  <overlay-loading *ngIf="loading"></overlay-loading>

  <search-filters
    [accountType]="loggedUser?.typeBusiness"
    [categories]="categories"
    [addresses]="addresses"
    [loading]="loading"
    [searchType]="searchType"
    [params]="searchParams"
    [currentLocation]="currentLocation"
    (onSearch)="search()"
  ></search-filters>

  <div class="listing-content-wrapper colab-toggleAnimateIn--js">

    <search-no-results
      *ngIf="!establishmentsOnline.length && !establishments.length && !cashbackPartners.length && !loading"
      [ownPartnershipsOnly]="ownPartnershipsOnly"
      [searchParams]="searchParams.name">
    </search-no-results>

    <search-results
      [ownPartnershipsOnly]="ownPartnershipsOnly"
      [loading]="loading"
      [establishments]="establishments"
      [establishmentsOnline]="establishmentsOnline"
      [cashbackPartners]="cashbackPartners"
      [searchType]="searchType"
      [loggedUser]="loggedUser"
      [scrolling]="scrolling"
      (scrollSearch)="scrollSearch()"
    ></search-results>

    <establishments-map
      *ngIf="!ownPartnershipsOnly && !searchType.seeMore"
      [establishments]="establishments"
      [currentLocation]="searchParams.location"
    ></establishments-map>
  </div>

</div>
